<template>
  <div style="height: auto">
    <my-asidebar v-bind:active-tab="'reports'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <button v-on:click="saveDesign">Save Design</button>
      <button v-on:click="exportHtml">Export HTML</button>
      <EmailEditor
          height="500px"
          ref="emailEditor"
          :min-height="1000"
          appearance="{
              theme: 'dark',
          panels: {
          tools: {
          dock: 'right',
          },
          },
          }"
          v-on:load="editorLoaded"
          v-on:ready="editorReady"
      />
    </section>

  </div>
<!--  <div class="container">-->
<!--    <div id="bar">-->
<!--      <h1>Vue Email Editor (Demo)</h1>-->

<!--      <button v-on:click="saveDesign">Save Design</button>-->
<!--      <button v-on:click="exportHtml">Export HTML</button>-->
<!--    </div>-->

<!--    <EmailEditor-->
<!--        ref="emailEditor"-->
<!--        v-on:load="editorLoaded"-->
<!--        v-on:ready="editorReady"-->
<!--    />-->
<!--  </div>-->
<!--  </div>-->
</template>

<script>

import { EmailEditor } from 'vue-email-editor';
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";


export default {
  name: "EmailEditorPage",
  components: {MyAsidebar,  TopBar, EmailEditor},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
  },
  methods: {
    // called when the editor is created
    async editorLoaded() {
      console.log('editorLoaded');
      $("iframe").css("height","915px")
      // // Pass the template JSON here
      // let data = {};
      // data.design = "";
      // data.values = [];
      // // await this.$refs.emailEditor.editor.loadDesign(JSON.stringify(data));
      // await this.$refs.emailEditor.editor.loadDesign({});
    },
    // called when the editor has finished loading
    editorReady() {
      console.log('editorReady');
    },
    saveDesign() {
      this.$refs.emailEditor.editor.saveDesign((design) => {
        console.log('saveDesign', design);
      });
    },
    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml((data) => {
        console.log('exportHtml', data);
      });
    },
  }
}
</script>

<style scoped>

</style>